export default {
  WAITING: 0,
  UPLOADING: 1,
  FAILED: 2,
  UNSUPPORTED: 3,
  COMPLETE: 4,
  CANCELLED: 5,
};
